import React, { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children, requireProfile = false }) {
  const { user, loading, profile } = useAuth();
  const loc = useLocation();
  // Memoize the navigate state so it's a stable object reference between renders.
  const navState = useMemo(() => ({ from: loc }), [loc]);
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
        <div className="w-10 h-10 border-2 border-[#E50914] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={navState} replace />;
  if (requireProfile && !profile) return <Navigate to="/profiles" replace />;
  return children;
}
